import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { SharedConstants } from '@app/eds';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit, OnChanges {
  // Total number of pages
  @Input() totalPages: number = SharedConstants.ONE;

  // The page that is displayed currently
  @Input() currentPageNumber: number = SharedConstants.ONE;

  //to enable or disable the navigation
  @Input() navigationDisabled = false;

  // total number of records
  @Input() totalRecords!: number;

  // whether to show range of records for the current page or not
  @Input() showItemsRange = false;

  // limitPerPage provides info about how many items per page
  @Input() limitPerPage!: number;

  // starting index of the range
  start!: number;

  // end index of the range
  end!: number;

  // Event emitter to emit an event when the next icon is clicked on
  @Output() nextButtonEventEmitter: EventEmitter<number> = new EventEmitter();

  // Event emitter to emit an event when the previous icon is clicked on
  @Output() previousButtonEventEmitter: EventEmitter<number> = new EventEmitter();

  ngOnInit(): void {
    this.initPagination();
  }

  ngOnChanges(): void {
    this.currentPageNumber === SharedConstants.ONE && this.initPagination();
  }

  /**
   * This function is called when the user clicks on the next icon
   * Increments the currentPageNumber by 1
   * Emits an event that can be used by the parent component
   */
  onNextButtonClick = () => {
    if (this.isNextBtnEnabled()) {
      if (this.end < this.totalRecords && this.showItemsRange) {
        this.currentPageNumber += 1;
        this.paginate(this.currentPageNumber, this.limitPerPage);
      }
      this.nextButtonEventEmitter.emit();
    }
  };

  /**
   * This function is called when the user clicks on the previous icon
   * Decrements the currentPageNumber by 1
   * Emits an event that can be used by the parent component
   */
  onPreviousButtonClick = () => {
    if (this.isPreviousBtnEnabled()) {
      if (this.showItemsRange) {
        this.currentPageNumber -= 1;
        this.paginate(this.currentPageNumber, this.limitPerPage);
      }
      this.previousButtonEventEmitter.emit();
    }
  };

  /**
   * This function is called to check if the previous icon should be enabled
   *
   * @returns boolean to specify if the previous icon should be enabled
   */
  isPreviousBtnEnabled = () => this.currentPageNumber > 1 && !this.navigationDisabled;

  /**
   * This function is called to check if the next icon should be enabled
   *
   * @returns boolean to specify if the next icon should be enabled
   */
  isNextBtnEnabled = () =>
    this.currentPageNumber < this.totalPages && !this.navigationDisabled;

  /**
   * This method will help to call the paginate()
   *  method with current page number and the limit
   */
  initPagination = () => this.paginate(this.currentPageNumber, this.limitPerPage);

  /**
   * This  method will help to calculate
   * the start and end index of the range for a particular page
   *
   * @param {number} page
   * @param {number} pageSize
   */
  paginate = (page: number, pageSize: number) => {
    const startPortion = page * pageSize - pageSize;
    let endPortion = startPortion + pageSize;
    if (endPortion > this.totalRecords) {
      endPortion -= endPortion - this.totalRecords;
    }
    this.saveCalculatedPortion(startPortion, endPortion);
  };

  /**
   * This method will help to update
   * the start and end index of the range
   *
   * @param {number} start
   * @param {number} end
   */
  saveCalculatedPortion = (start: number, end: number) => {
    this.start = start;
    this.end = end;
  };
}
